module.exports = __webpack_public_path__ + "img/grop-1.3a16c1ca.png";